import { z } from 'zod'
import { clientPurchaseOrderSchema, printableTextRegex } from '@/lib/validations/auth'

export const purchaseOrderFormSchema = clientPurchaseOrderSchema
  .extend({
    client_id: z.coerce
      .number({ invalid_type_error: 'Client is required' })
      .int()
      .positive('Client is required'),
    domain: z
      .string()
      .max(255)
      .optional()
      .nullable()
      .refine((val) => !val || printableTextRegex.test(val), 'Domain contains invalid characters'),
    po_date: z.string().min(1, 'PO date is required'),
    start_date: z.string().min(1, 'Start date is required'),
    end_date: z.string().min(1, 'End date is required'),
  })
  .refine(
    (data) => {
      if (!data.start_date || !data.end_date) return true
      return data.end_date > data.start_date
    },
    { message: 'End date must be after start date', path: ['end_date'] }
  )

export type PurchaseOrderFormData = z.infer<typeof purchaseOrderFormSchema>
